/* eslint-disable no-console */
import { register } from "register-service-worker";

async function printCacheInfo() {
  if (!('caches' in window)) return;

  const cacheNames = await caches.keys();
  for (const name of cacheNames) {
    const cache = await caches.open(name);
    const requests = await cache.keys();
    console.log(`[PWA Cache] ${name}: ${requests.length} files`);
  }
}

async function clearPwaCache() {
  // 删除所有 Cache Storage
  const cacheNames = await caches.keys();
  for (const name of cacheNames) {
    await caches.delete(name);
  }

  // 注销 Service Workers
  const regs = await navigator.serviceWorker.getRegistrations();
  for (const reg of regs) {
    await reg.unregister();
  }

  alert("Cache cleared successfully!\nPlease reload the page to apply updates.");
  window.location.reload();
}


// 暴露给浏览器控制台调用
// console中输入 clearPwaCache() 可一键清除
Object.assign(window, { clearPwaCache });


if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log("App running with service worker.");
      printCacheInfo();
    },
    registered() {
      console.log("Service worker registered.");
      printCacheInfo();
    },
    cached() {
      console.log("Content cached for offline use.");
      printCacheInfo();
    },
    updatefound() {
      console.log("New content downloading.");
    },
    updated() {
      console.log("New content available; please refresh.");
      printCacheInfo();
    },
    offline() {
      console.log("No internet connection. Running offline.");
      printCacheInfo();
    },
    error(error) {
      console.error("Error registering service worker:", error);
    }
  });
}